import React, {forwardRef} from "react";
import classNames from "classnames";
import "@/Scss/Components/formInput.scss";

const Input = forwardRef((props, ref) => {
    const {
        as = 'input', // 'input' | 'textarea'
        variant = 'site', // site | admin
        type = 'text',
        name = '',
        value = '',
        placeholder = '',
        autoComplete,
        autoFocus = false,
        required = false,
        disabled = false,
        className = '',
        style = {},
        message,
        onChange = () => {
        },
        onFocus = () => {
        },
        onBlur = () => {
        },
    } = props;

    const inputClasses = classNames(`formInput`, `formInput--${variant}`, `formInput--${as}`, className, {
        'error': message,
    });

    const textareaClasses = classNames(`formInput`, `formInput--${variant}`, `formInput--${as}`, className, {
        'formInput--textareaSite': variant === 'site',
        'formInput--textareaAdmin': variant === 'admin',
        'error': message,
    });

    // const inputClassName = classNames('formInput', className, {
    //     'error': message,
    // });
    //
    // const textareaClassName = classNames('formInput formInput--textarea', className, {
    //     'error': message,
    // });

    if (as === 'textarea') {
        return (
            <textarea
                ref={ref}
                id={name}
                name={name}
                value={value}
                placeholder={placeholder}
                // autoComplete={autoComplete ?? name}
                className={textareaClasses}
                style={style}
                required={required}
                disabled={disabled}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
            />
        );
    }

    return (
        <input
            ref={ref}
            id={name}
            name={name}
            type={type}
            value={value}
            placeholder={placeholder}
            autoComplete={autoComplete ?? name}
            className={inputClasses}
            style={style}
            autoFocus={autoFocus}
            required={required}
            disabled={disabled}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
        />
    );
});

export default Input;
